'use strict';

var xmlEntities = require('html-entities/lib/xml-entities');
var countedForm_index = require('./counted-form/index.js');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

exports.__assign = function() {
    exports.__assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return exports.__assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* eslint-disable no-useless-escape, max-params, no-param-reassign */
var VARIABLE_REGEXP = /{{([\w+|\-]+)}}/g;
var COMMON_WORD_REGEXP = /\[\[([^:\]]+):([^\]@]+)(@[^\]]+)?\]\]/g;
var DECLINABLE_VARIABLE_REGEXP = /{{([\w+|\-]+)@([c|n])?(\d+)}}/g;
var PARTNER_NAME_REGEXP = /^(page_?)partner_name$/gi;
var MALE = 'M';
var FEMALE = 'F';
var UNSPECIFIED = 'U';
var HasCountableForm = /** @class */function () {
  function HasCountableForm(value, count, defaultDeclination) {
    this.value = value;
    this.count = count;
    this.defaultDeclination = defaultDeclination;
  }
  HasCountableForm.prototype.getValue = function (_a, dec) {
    var commonWords = _a.commonWords,
      lang = _a.lang;
    var declined = this.value;
    var wordForms = commonWords[this.value];
    if (wordForms) {
      var form = countedForm_index.getCountedForm(lang, this.count);
      var wordForm = wordForms[form] || wordForms[countedForm_index.getDefaultCountedForm()];
      if (Array.isArray(wordForm)) {
        declined = wordForm[dec || this.defaultDeclination || 0] || wordForm[0];
      } else {
        declined = wordForm;
      }
    }
    return declined;
  };
  HasCountableForm["for"] = function (value, count, defaultDeclination) {
    return new HasCountableForm(value, count, defaultDeclination);
  };
  return HasCountableForm;
}();
var HasGender = /** @class */function () {
  function HasGender(value, gender) {
    this.value = value;
    this.gender = gender;
  }
  HasGender.prototype.getValue = function () {
    return this.value;
  };
  HasGender.prototype.toString = function () {
    return this.getValue();
  };
  HasGender["for"] = function (value, gender) {
    return new HasGender(value, gender);
  };
  return HasGender;
}();
var Name = /** @class */function () {
  function Name(name) {
    this.name = name;
  }
  Name.prototype.getValue = function (_a, dec) {
    var names = _a.names;
    var decs = names[this.name.toLowerCase()];
    return decs && dec !== undefined && decs[dec] ? decs[dec] : this.name;
  };
  Name["for"] = function (name) {
    return new Name(name);
  };
  return Name;
}();
var City = /** @class */function () {
  function City(city) {
    this.city = city;
  }
  City.prototype.getValue = function (_a, dec) {
    var cities = _a.cities;
    var decs = cities[this.city.toLowerCase()];
    return decs && dec !== undefined && decs[dec] ? decs[dec] : this.city;
  };
  City["for"] = function (loc) {
    return new City(loc);
  };
  return City;
}();
var Partner = /** @class */function () {
  function Partner(partner) {
    this.partner = partner;
  }
  Partner.prototype.getValue = function (_a, dec) {
    var partnerNames = _a.partnerNames;
    var declined = this.partner;
    var partnerNameForms = partnerNames[this.partner];
    if (dec !== undefined && partnerNameForms && partnerNameForms.singular && partnerNameForms.singular[dec]) {
      declined = partnerNameForms.singular[dec];
    }
    return declined;
  };
  Partner["for"] = function (partner) {
    return new Partner(partner);
  };
  return Partner;
}();
var TrustedValue = /** @class */function () {
  function TrustedValue(value) {
    this.value = value;
  }
  TrustedValue.prototype.getValue = function () {
    return this.value;
  };
  TrustedValue.prototype.toString = function () {
    return this.getValue();
  };
  TrustedValue["for"] = function (value) {
    return new TrustedValue(value);
  };
  return TrustedValue;
}();
function isLocalisationHelpersClassInstance(instance) {
  return instance instanceof TrustedValue || instance instanceof HasCountableForm || instance instanceof HasGender || instance instanceof Name || instance instanceof City || instance instanceof Partner;
}
var Localization = /** @class */function () {
  function Localization(lang) {
    this.lang = lang;
    this.abTests = {};
    this.entries = {};
    this.commonWords = {};
    this.names = {};
    this.cities = {};
    this.partnerNames = {};
    this.defaultVars = {};
    this.gender = UNSPECIFIED;
    this.showLexemeKeys = false;
  }
  Localization.prototype.setLang = function (lang) {
    this.lang = lang;
  };
  Localization.prototype.setABTest = function (name, variation) {
    this.abTests[name] = variation;
  };
  Localization.prototype.setABTests = function (abTests) {
    this.abTests = abTests;
  };
  Localization.prototype.setGender = function (gender) {
    this.gender = gender;
  };
  Localization.prototype.setEntries = function (entries) {
    this.entries = entries;
  };
  Localization.prototype.setCommonWords = function (commonWords) {
    this.commonWords = commonWords;
  };
  Localization.prototype.setPartnerNames = function (partnerNames) {
    this.partnerNames = partnerNames;
  };
  Localization.prototype.setCities = function (cities) {
    this.cities = cities;
  };
  Localization.prototype.setNames = function (names) {
    this.names = names;
  };
  Localization.prototype.setShowLexemeKeys = function (showLexemeKeys) {
    this.showLexemeKeys = showLexemeKeys;
  };
  Localization.prototype.setHighlightLexemes = function (highlightLexemes) {
    this.highlightLexemes = highlightLexemes;
  };
  Localization.prototype.setDefaultVars = function (defaultVars) {
    this.defaultVars = defaultVars;
  };
  Localization.prototype.setAbTestHitCallback = function (abTestCallback) {
    this.abTestCallback = abTestCallback;
  };
  /**
   * The localization entries can be:
   *  A number in production to save bundle size
   *  A string in development containing the lexeme ids
   */
  Localization.prototype.get = function (handle, vars) {
    var entry = this.entries[handle];
    var resolvedValue;
    if (entry) {
      resolvedValue = this.resolveValue(entry, vars ? exports.__assign(exports.__assign({}, vars), this.defaultVars) : this.defaultVars);
    }
    if (typeof resolvedValue === 'undefined') {
      // Handle special case of just getting lexeme by it's id
      if (typeof handle === 'string' && entry && !vars) {
        return entry;
      }
      throw new Error("No lexeme found for ".concat(handle));
    }
    return resolvedValue;
  };
  Localization.prototype.resolveValue = function (entry, vars) {
    var resolved;
    if (typeof entry === 'string') {
      return this.setVars(entry, vars);
    } else if (entry.__list) {
      resolved = this.applyList(entry.__list, entry.glue, vars);
    } else if (entry.__gender) {
      resolved = this.applyGender(entry.__gender, vars);
    } else if (entry.__cfg) {
      resolved = this.applyCfg(entry.__cfg, vars);
    }
    return typeof resolved === 'string' ? this.setVars(resolved, vars) : resolved;
  };
  // __list
  Localization.prototype.applyList = function (list, glue, vars) {
    var _this = this;
    // eslint-disable-next-line id-blacklist, id-length
    return list.map(function (e) {
      return _this.resolveValue(e, vars);
    }).join(glue || ' ');
  };
  // __gender
  Localization.prototype.applyGender = function (_a, vars) {
    var keys = _a.keys,
      map = _a.map,
      list = _a.list;
    var key = keys.map(function (varName) {
      var value = vars[varName];
      if (!(value instanceof HasGender)) {
        throw new Error("Variable ".concat(varName, " is not of HasGender type"));
      }
      return "".concat(varName, "=").concat(value.gender);
    }).join('&');
    var id = map[key];
    if (!id) {
      throw new Error("No gender specific item found for ".concat(key, " input"));
    }
    return this.resolveValue(list[id], vars);
  };
  // __cfg
  Localization.prototype.applyCfg = function (cfg, vars) {
    var values = cfg.values;
    if ('ab_test' in cfg && cfg.ab_test) {
      var testName = cfg.ab_test.key;
      var variation = this.abTests[testName];
      if (this.abTestCallback) {
        this.abTestCallback(testName);
      }
      if (variation) {
        values = cfg.ab_test.variants[variation].values;
      }
    }
    var result = values.Default;
    if ('flex_vars_types' in cfg && cfg.flex_vars_types) {
      result = this.getFlexible(values, cfg.flex_vars_types, vars);
    }
    return result;
  };
  Localization.prototype.getFlexible = function (values, flexTypes, vars) {
    var keyAll = this.buildFlexibleKey(values, flexTypes, vars, Object.keys(flexTypes));
    var keyNoGender = this.buildFlexibleKey(values, flexTypes, vars,
    // eslint-disable-next-line id-length
    Object.keys(flexTypes).filter(function (k) {
      return /__gender_/.test(k) === false;
    }));
    var all = values[keyAll];
    var noGender = values[keyNoGender];
    return all || noGender || values.Default;
  };
  Localization.prototype.buildFlexibleKey = function (_values, flexTypes, vars, filterKeys) {
    var _this = this;
    var result = filterKeys
    // eslint-disable-next-line complexity
    .map(function (key) {
      var keyValue;
      // eslint-disable-next-line default-case
      switch (flexTypes[key]) {
        case 'City':
          keyValue = Object.entries(_this.cities[vars[key].toLowerCase()] || {}).length ? 1 : 0;
          break;
        case 'Name':
          keyValue = Object.entries(_this.names[String(vars[key]).toLowerCase()] || {}).length ? 1 : 0;
          break;
        case 'Num':
          keyValue = countedForm_index.getCountedForm(_this.lang, Number(vars[key]));
          break;
        case 'Gender':
          {
            // Context gender?
            if (key === '__ctx_gender') {
              keyValue = _this.gender;
            } else {
              var varsKey = key.replace('__gender_', '');
              var varsValue = vars[varsKey];
              if (varsValue instanceof HasGender) {
                // value with gender
                keyValue = varsValue.gender;
              } else if (typeof varsValue === 'string' && [MALE, FEMALE, UNSPECIFIED].includes(varsValue)) {
                // gender itself
                keyValue = varsValue;
              } else {
                // fallback to unspecified
                keyValue = UNSPECIFIED;
              }
            }
            break;
          }
      }
      return "".concat(key, "=").concat(keyValue);
    }).sort().join(';');
    return result;
  };
  Localization.prototype.setVars = function (template, vars) {
    return template.replace(VARIABLE_REGEXP, this.getValue.bind(this, vars)).replace(COMMON_WORD_REGEXP, this.getCommonWordValue.bind(this, vars)).replace(DECLINABLE_VARIABLE_REGEXP, this.getDeclinationValue.bind(this, vars));
  };
  // eslint-disable-next-line class-methods-use-this
  Localization.prototype.getValue = function (vars, _match, variable) {
    var result = '';
    if (typeof vars[variable] !== 'undefined') {
      var val = vars[variable];
      if (isLocalisationHelpersClassInstance(val)) {
        result = val.getValue(this);
      } else {
        result = new xmlEntities.XmlEntities().encode(String(val));
      }
    }
    return result;
  };
  Localization.prototype.getCommonWordValue = function (vars, _match, varName, dependsOn, dec) {
    var value = vars[varName] || varName;
    if (!(value instanceof HasCountableForm)) {
      var dependingVar = vars[dependsOn];
      if (typeof dependingVar !== 'number') {
        if (typeof dependingVar === 'string') {
          dependingVar = parseInt(dependingVar, 10);
        }
        dependingVar = typeof dependingVar === 'number' ? dependingVar : 0;
        console.warn("Invalid vars provided for common word '".concat(varName, "' - ").concat(vars[dependsOn]));
      }
      value = new HasCountableForm(varName, dependingVar);
    }
    var declination;
    if (typeof dec === 'string') {
      if (dec[0] === '@') {
        declination = Number(dec.slice(1));
      } else {
        declination = Number(dec);
      }
    }
    return this.getDeclinedCommonWord(value, declination);
  };
  Localization.prototype.getDeclinationValue = function (vars, _match, varName, type, declination) {
    var declined;
    var value = vars[varName];
    var dec = Number(declination);
    if (type === 'c' && typeof value === 'string') {
      declined = this.getDeclinedCity(value, dec);
    } else if (type === 'n' && typeof value === 'string') {
      declined = this.getDeclinedName(value, dec);
    } else if (this.isPartnerName(value)) {
      declined = this.getDeclinedPartner(value, dec);
    } else {
      declined = this.getDeclinedCommonWord(value, dec);
    }
    return declined;
  };
  Localization.prototype.getDeclinedCity = function (city, dec) {
    if (!(city instanceof City)) {
      city = new City(city);
    }
    return city.getValue(this, dec);
  };
  Localization.prototype.getDeclinedName = function (name, dec) {
    if (!(name instanceof Name)) {
      name = new Name(name);
    }
    return name.getValue(this, dec);
  };
  Localization.prototype.getDeclinedPartner = function (partner, dec) {
    if (!(partner instanceof Partner)) {
      partner = new Partner(partner);
    }
    return partner.getValue(this, dec);
  };
  Localization.prototype.getDeclinedCommonWord = function (word, dec) {
    if (!(word instanceof HasCountableForm)) {
      throw new Error('Should be an instance of CommonWord');
    }
    return word.getValue(this, dec);
  };
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-explicit-any
  Localization.prototype.isPartnerName = function (variable) {
    return variable instanceof Partner || typeof variable === 'string' && PARTNER_NAME_REGEXP.test(variable.toLowerCase());
  };
  return Localization;
}();

exports.City = City;
exports.FEMALE = FEMALE;
exports.HasCountableForm = HasCountableForm;
exports.HasGender = HasGender;
exports.Localization = Localization;
exports.MALE = MALE;
exports.Name = Name;
exports.Partner = Partner;
exports.TrustedValue = TrustedValue;
exports.UNSPECIFIED = UNSPECIFIED;
exports.__extends = __extends;
